// extracted by mini-css-extract-plugin
export default {"container":"Contactanos_container__Ekm3q","title":"Contactanos_title__ibnxk","text":"Contactanos_text__p2p7j"};